import { render } from "./IHIHistoryModal.vue?vue&type=template&id=467d283f"
import script from "./IHIHistoryModal.vue?vue&type=script&lang=js"
export * from "./IHIHistoryModal.vue?vue&type=script&lang=js"

import "./IHIHistoryModal.vue?vue&type=style&index=0&id=467d283f&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__